import { Divider, Stack, Wrap } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { memo } from "react";
import { MenuItem } from "./MenuItem";

export const SocialNetworks = memo(function SocialNetworks() {
  const { menu } = useConfigurationMenu({ alias: "social-networks" });

  return (
    <Stack spacing="1.5rem">
      <Divider borderColor="#fff" />

      <Wrap spacing="0">
        {menu?.items?.map((menuItem, index) => {
          return <MenuItem menuItem={menuItem} key={index} />;
        })}
      </Wrap>
    </Stack>
  );
});
